import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NumberingLinkedWithSalePatternError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.numberings.validation.active.numbering-linked-with-sale-pattern');
    }
}
